import { metaTagString } from '../../utilities/meta_tags_util';

export default {
  landingPage(urlPath, language, query, params) {
    return {
      metaData: null,
    };
  },
  qrcode(urlPath, language, query, params) {
    return {
      metaData: null,
    };
  },
  privacyPolicy(urlPath, language, query, params) {
    let metaData = '';

    switch (language) {
      case 'zh-cn': {
        metaData += metaTagString({
          urlPath,
          title: 'Privacy Policy',
          description: '透过 Funliday 寻找下一趟旅程，轻松安排旅游行程。',
          language,
          noindex: true,
        });

        break;
      }
      case 'zh-tw': {
        metaData += metaTagString({
          urlPath,
          title: 'Privacy Policy',
          description: '透過 Funliday 尋找下一趟旅程，輕鬆安排旅遊行程。',
          language,
          noindex: true,
        });

        break;
      }
      case 'ja': {
        metaData += metaTagString({
          urlPath,
          title: 'Privacy Policy',
          description:
            'Funliday は、次の旅行先を見つけるお手伝いをしてくれます！次の旅行に活用して楽に計画しよう！',
          language,
          noindex: true,
        });

        break;
      }
      case 'ko': {
        metaData += metaTagString({
          urlPath,
          title: 'Privacy Policy',
          description:
            'Funliday 는 다음 목적지를 찾고 여행을 쉽게 구성 할 수 있도록 도와줍니다.',
          language,
          noindex: true,
        });

        break;
      }
      default: {
        metaData += metaTagString({
          urlPath,
          title: 'Privacy Policy',
          description:
            'Funliday helps you find the next destination and organize your trip easily.',
          language,
          noindex: true,
        });

        break;
      }
    }

    return {
      metaData,
    };
  },
};
